import { GetOrdersQueryParamsType, ServiceOrder } from '@dostavkee/contracts-console/entities'
import {
    getOrdersPublicIdQueryKey,
    getOrdersQueryKey,
    getUsersProfileBalanceQueryKey,
    usePatchOrdersId,
} from '@dostavkee/contracts-console/hooks'
import * as Sentry from '@sentry/react'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { ERROR_CODE, ERROR_CODE_MESSAGE } from '@/shell/shared/config'

interface UseOrderUpdatePriceProps {
    order: ServiceOrder
}

export const useOrderUpdatePrice = ({ order }: UseOrderUpdatePriceProps) => {
    const queryClient = useQueryClient()

    const { mutate, isPending } = usePatchOrdersId({
        mutation: {
            onSuccess: async () => {
                /**
                 * Обновляем баланс пользователя
                 */
                await queryClient.invalidateQueries({
                    queryKey: getUsersProfileBalanceQueryKey(),
                })

                /**
                 * Обновляем кэш заказа
                 */
                await queryClient.invalidateQueries({
                    queryKey: getOrdersPublicIdQueryKey(order.public_id.toString()),
                })

                /**
                 * Обновляем кэш списка активных заказов
                 */
                await queryClient.invalidateQueries({
                    queryKey: getOrdersQueryKey({ type: GetOrdersQueryParamsType.active }),
                })

                toast.success('Цена заказа успешно поднята')
            },

            onError: (error) => {
                if (error.error_code === ERROR_CODE.ORDER_EDIT_COOLDOWN_ERROR_CODE) {
                    toast.error(ERROR_CODE_MESSAGE.get(error.error_code))

                    return
                }

                toast.error('Не удалось поднять цену заказа')

                Sentry.captureException(error)
            },
        },
    })

    return {
        mutate,
        isPending,
    }
}
